import { nanoid } from '@reduxjs/toolkit';

export enum EConditionType {
  QuestionAnswer = 'question_answer',
  InterviewProperty = 'interview_property',
  CandidateProperty = 'candidate_property',
  RandomNumber = 'random_number',
}

export enum EActionName {
  Show = 'SHOW',
}

export const conditionTypes = [
  { label: 'Question Answer', value: EConditionType.QuestionAnswer },
  { label: 'Interview property', value: EConditionType.InterviewProperty },
  { label: 'Candidate property', value: EConditionType.CandidateProperty },
  { label: 'Random number', value: EConditionType.RandomNumber },
];

const OPERATORS = {
  EQUALS: 'EQUALS',
  eq: 'EQUALS',
  IS: 'IS',
  is: 'IS',
  IS_NOT: 'IS_NOT',
  is_not: 'IS_NOT',
  IS_IN: 'IS_IN',
  is_in: 'IS_IN',
  IS_NOT_IN: 'IS_NOT_IN',
  is_not_in: 'IS_NOT_IN',
  INCLUDES: 'INCLUDES',
  includes: 'INCLUDES',
  GREATER_THAN: 'GREATER_THAN',
  gt: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  lt: 'LESS_THAN',
  STRING_LENGTH: 'STRING_LENGTH',
};

export enum ERuleType {
  DO_IF = 'DO_THIS_IF',
  SHOW_IF = 'SHOW_THIS_IF',
}

type TQuestionRuleType = ERuleType.DO_IF | ERuleType.SHOW_IF;

type QuestionRuleConditionType =
  | EConditionType.QuestionAnswer
  | EConditionType.InterviewProperty
  | EConditionType.CandidateProperty
  | EConditionType.RandomNumber;

export type TQuestionRuleCondition = {
  id: string;
  name: string;
  type: QuestionRuleConditionType;
  operator?: string;
  value: string | string[] | number[] | number;
  apply_to_form_id?: string;
  property?: string;
  question_id?: string;
  // Mirrors the package's TQuestionRuleCondition.fallback; set on 'total_score' conditions.
  fallback?: {
    property: 'qualified';
    value: 'qualified' | 'not_qualified';
    min_bonuspoints?: number;
  };
};

export function newCondition() {
  const c = {
    id: nanoid(),
    name: '',
    type: EConditionType.QuestionAnswer,
    operator: OPERATORS.EQUALS,
    value: [],
  };
  return c;
}

export function newAction(actionName?: string) {
  const action = {
    id: nanoid(),
    name: actionName ?? '',
    value: [],
  };
  return action;
}

export type TQuestionRuleAction = {
  id: string;
  name: string;
  value: (string | { id: string })[];
};

export type TQuestionRule = {
  id: string;
  name: string;
  type: TQuestionRuleType;
  operator: 'AND' | 'OR';
  conditions: TQuestionRuleCondition[];
  actions?: TQuestionRuleAction[];
};

export function ruleType1() {
  const rule: TQuestionRule = {
    id: nanoid(),
    name: 'Rule - Do This If',
    type: ERuleType.DO_IF,
    operator: 'AND',
    conditions: [],
    actions: [],
  };
  return rule;
}

export function ruleType2() {
  const rule: TQuestionRule = {
    id: nanoid(),
    name: 'Rule - Show This If',
    type: ERuleType.SHOW_IF,
    operator: 'AND',
    conditions: [],
  };
  return rule;
}
